import React from 'react';

const BastionButton = ({ client }) => {
  // Vérifier si le bastion est configuré et activé
  if (!client?.bastionConfig?.enabled || !client?.bastionConfig?.url?.trim()) {
    return null;
  }

  const handleClick = () => {
    // Ouvrir l'URL du bastion dans un nouvel onglet
    window.open(client.bastionConfig.url, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      onClick={handleClick}
      className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-md transition-colors"
      title={`Accéder au bastion de connexion - ${client.bastionConfig.url}`}
    >
      <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-2M7 13l3 3 7-7" />
      </svg>
      {client.bastionConfig.displayName || 'Bastion'}
    </button>
  );
};

export default BastionButton;
